/* eslint-disable no-restricted-imports */
import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import ClappsToggleView from '~/client/components/Game/GameView/shared/ClappsToggle';
import canShowFunMode from '~/shared/utils/canShowFunMode';
import FullscreenToggle from './FullscreenToggle';
import FunModeToggle from './FunModeToggle';
import UserFooter from './UserFooter';
import GameCurrency from '@/server/components/Game/GameCurrencySelect/useGameCurrencySelect/GameCurrency';

type Props = {
  gameCurrencySelect: GameCurrency;
  translations: Record<string, string>;
};

const StandardGamesFooter: FC<Props> = ({
  gameCurrencySelect,
  translations,
}) => {
  const { game } = useGameContext();

  return (
    <div
      className="flex h-16 w-full items-center justify-between"
      data-testid="game-footer"
    >
      <UserFooter
        gameCurrencySelect={gameCurrencySelect}
        translations={translations}
      />
      <div className="hidden sm:inline-container gap-4">
        <ClappsToggleView />
        {canShowFunMode(game) && <FunModeToggle />}
        <FullscreenToggle />
      </div>
    </div>
  );
};

export default StandardGamesFooter;
